module.exports = __webpack_public_path__ + "img/plate01_02.f3430e2d.png";